import { inject, Injectable } from '@angular/core';
import { forkJoin, from, Observable, of, switchMap } from 'rxjs';
import { CtDocument } from '@ps-gui/claims-terminal-shared';

import { CtBatchStoreService } from '../app-state/ct-batch-store.service';
import { PersistDataService } from '../app-state/persist-data.service';
import { ExtractionTrainingDataService } from '../training/extraction-training-data.service';
import { TrainingApiService } from '../training/training-api.service';

@Injectable({ providedIn: 'root' })
export class ExtractionTrainingSubmissionService {
  private readonly ctBatchStoreService = inject(CtBatchStoreService);
  private readonly persistDataService = inject(PersistDataService);
  private readonly trainingDataService = inject(ExtractionTrainingDataService);
  private readonly trainingApiService = inject(TrainingApiService);

  submitTrainingDataForDocuments() {
    const trainingDocuments = this.ctBatchStoreService.ctBatch.documents.filter((document) =>
      this.persistDataService.shouldUseTrainingDataForDocument(document.id),
    );
    return trainingDocuments.length === 0
      ? of([])
      : forkJoin(
          trainingDocuments.flatMap((document) => this.submitTrainingDataForDocument(document)),
        );
  }

  private submitTrainingDataForDocument(document: CtDocument): Observable<void>[] {
    return document.documentClasses.map((documentClass) =>
      from(this.trainingDataService.getExtractionTrainingData(document.id, documentClass)).pipe(
        switchMap((data) =>
          this.trainingApiService.submitTrainingData({
            ...data,
            documentId: document.id,
            documentClass,
          }),
        ),
      ),
    );
  }
}
